// Centralized API configuration
// Uses relative URL in production, env variable only in local development

const getApiBaseUrl = () => {
  // Check if we're in a production environment (deployed domain)
  // Production domains don't contain 'localhost' or 'preview'
  const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
  const isLocalDev = hostname === 'localhost' || hostname === '127.0.0.1';
  const isPreview = hostname.includes('preview.emergentagent.com');
  
  // Only use REACT_APP_BACKEND_URL for local development or preview environments
  if ((isLocalDev || isPreview) && process.env.REACT_APP_BACKEND_URL) {
    return process.env.REACT_APP_BACKEND_URL;
  }
  
  // In production (custom domains like nouveaurichelegacy.com), use relative URL
  // This ensures API calls go to the same domain the frontend is served from
  return '';
};

export const API_BASE_URL = getApiBaseUrl();
export const API = `${API_BASE_URL}/api`;

export default API;
